// All user-facing copy lives in catalogues so Hindi and regional UIs can follow.
export const en = {
  tagline: "Bluff your friends with fake answers to real Indian trivia. Spot the truth to win.",
  host: "Host a game",
  orJoin: "or join your friends",
  roomCode: "Room code",
  join: "Join",
  footer: "Free · No sign-up · 3 to 10 players",
  howToPlay: "How to play",
  codeInvalid: "Room codes are 5 letters and numbers.",
  howSteps: [
    "Everyone sees the same surprising question.",
    "Write a fake answer that sounds real.",
    "Pick the real answer from everyone's bluffs.",
    "1000 points for finding the truth, 500 for each friend you fool. The last round counts double.",
  ],

  // Joining
  yourName: "Your name",
  namePlaceholder: "e.g. Meera",
  pickColour: "Pick a colour",
  createRoom: "Create room",
  joinRoom: "Join room",
  joiningRoom: (code: string) => `Join room ${code}`,
  hostedBy: (name: string, n: number) => `${name}'s room · ${n} ${n === 1 ? "player" : "players"}`,
  roomFull: "This room is full.",
  inProgress: "A game is on. You'll join from the next round.",
  continueAs: (name: string) => `Continue as ${name}`,
  joinAsNew: "Join as someone new",
  back: "Back",
  loading: "Loading…",
  roomGone: "This room has closed or doesn't exist.",
  goHome: "Back to home",

  // Connection
  connecting: "Connecting…",
  reconnecting: "Reconnecting…",
  kickedRemoved: "The host removed you from the room.",
  kickedExpired: "You were away too long and lost your seat.",
  kickedLeft: "You left the room.",
  roomClosed: "This room has closed.",
  reload: "A new version of DesiPsych is out.",
  reloadNow: "Refresh",
  rejoin: "Join again",

  // Lobby
  lobby: "Lobby",
  shareCode: "Share this code",
  copyLink: "Copy invite link",
  copied: "Copied!",
  share: "Share",
  players: (n: number) => `Players (${n}/10)`,
  you: "you",
  hostTag: "host",
  away: "away",
  makeHost: "Make host",
  remove: "Remove",
  settings: "Game settings",
  rounds: "Rounds",
  writeTime: "Writing time",
  voteTime: "Voting time",
  content: "Content",
  family: "Family",
  adult: "18+",
  decks: "Decks",
  allDecks: "All decks",
  start: "Start game",
  needPlayers: (n: number) => `Need ${n} more ${n === 1 ? "player" : "players"} to start`,
  waitingForHost: (name: string) => `Waiting for ${name} to start…`,
  leave: "Leave room",
  seconds: (n: number) => `${n}s`,

  // Round
  roundOf: (r: number, n: number) => `Round ${r} of ${n}`,
  finalRound: "Final round · double points!",
  writeFake: "Write a fake answer",
  fakePlaceholder: "Something believable…",
  submit: "Submit bluff",
  update: "Update bluff",
  yourBluff: "Your bluff",
  edit: "Edit",
  knewTruth: "You found the real answer! You won't score for picking it this round, so fool everyone instead.",
  waitingFor: (names: string) => `Waiting for ${names}`,
  everyoneDone: "Everyone's in!",
  nextRoundJoin: "You'll join in from the next round. Watch how it's done!",
  sachBolHint: "Sach Bol: there's no real answer. Write the funniest one, then vote for your favourite.",
  pickTruth: "Which one is the truth?",
  pickFavourite: "Which answer is the best?",
  voted: "Vote locked in. You can still change it.",
  heartsLeft: (n: number) => `${n} ${n === 1 ? "heart" : "hearts"} left`,
  heart: "Heart this answer",
  noOptions: "Nobody wrote a bluff this round.",

  // Reveal
  reveal: "The reveal",
  theTruth: "The truth!",
  bluffBy: (names: string) => `${names}'s bluff`,
  fooled: (names: string) => `Fooled: ${names}`,
  foundIt: (names: string) => `Found it: ${names}`,
  nobody: "nobody",
  skip: "Skip",
  report: "Report",
  reportTitle: "Report this answer",
  reportReasons: ["Offensive or hateful", "Sexual content", "Personal information", "Spam"],
  reportSent: "Thanks. A moderator will review it.",
  cancel: "Cancel",

  // Scoreboard
  scoreboard: "Scores",
  nextRound: "Next round",
  lastRoundNext: "See the results",

  // Final
  gameOver: "Game over",
  winner: (name: string) => `${name} wins!`,
  awards: "Awards",
  bestBluffer: "Master Bluffer",
  truthSeeker: "Truth Seeker",
  crowdFavourite: "Crowd Favourite",
  playAgain: "Play again",
  shareCard: "Share result",
  waitingPlayAgain: (name: string) => `Waiting for ${name} to start another game…`,

  // Toasts
  newHost: (name: string) => `${name} is now the host.`,
  youAreHost: "You're the host now.",
} as const;
